var CompareChannelService = (function () {
    function CompareChannelService($q, promptMessage) {
        this.$q = $q;
        this.promptMessage = promptMessage;
        this.stateKey = 'compare-products';
        this.onAddDefer = this.$q.defer();
        this.onRemoveDefer = this.$q.defer();
        this.onResetDefer = this.$q.defer();
        this.state = this.deserialize();
    }
    CompareChannelService.prototype.add = function (group) {
        var _this = this;
        if (group === void 0) { group = {}; }
        var groupIndex = this.findIndex(group);
        if (groupIndex > -1) {
            console.warn("Group is alread in state: " + group.groupId);
            return;
        }
        if (this.state.length === 3) {
            this.promptMessage.create('CompareUpTo3ProductsWarning').then(function () {
                _this.remove(_this.state[0]);
                _this.state.push(group);
                _this.serialize();
                _this.onAddDefer.notify(group);
            });
        }
        else {
            this.state.push(group);
            this.serialize();
            this.onAddDefer.notify(group);
        }
    };
    CompareChannelService.prototype.get = function () {
        return this.state;
    };
    CompareChannelService.prototype.onAdd = function () {
        return this.onAddDefer.promise;
    };
    CompareChannelService.prototype.onRemove = function () {
        return this.onRemoveDefer.promise;
    };
    CompareChannelService.prototype.onReset = function () {
        return this.onResetDefer.promise;
    };
    CompareChannelService.prototype.remove = function (group) {
        if (group === void 0) { group = {}; }
        var groupIndex = this.findIndex(group);
        if (groupIndex === -1) {
            console.warn("Group was not found in state: " + group.groupId);
            return;
        }
        this.state.splice(groupIndex, 1);
        this.serialize();
        this.onRemoveDefer.notify(group);
    };
    CompareChannelService.prototype.reset = function () {
        this.state.length = 0;
        this.serialize();
        this.onResetDefer.notify();
    };
    CompareChannelService.prototype.deserialize = function () {
        var serialized = sessionStorage.getItem(this.stateKey);
        var groups = serialized ? JSON.parse(serialized) : [];
        return groups;
    };
    CompareChannelService.prototype.findIndex = function (group) {
        var index = -1;
        for (var i = 0; i < this.state.length; i++) {
            if (this.state[i].groupId === group.groupId) {
                index = i;
                break;
            }
        }
        return index;
    };
    CompareChannelService.prototype.serialize = function () {
        var serialized = JSON.stringify(this.state);
        sessionStorage.setItem(this.stateKey, serialized);
    };
    CompareChannelService.$inject = ['$q', 'promptMessage'];
    return CompareChannelService;
}());
export { CompareChannelService };
